import React, { useState } from 'react';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import jwt_decode from 'jwt-decode';
// Components
import UserIcon from 'assets/images/svg/UserIcon';
import DownArrow from 'assets/images/svg/DownArrow';
// Helpers
import { handleLogOut } from 'constants/Helpers';
// Localstorage
import { getFromLocalStorage } from 'helpers/LocalStorage';

const getUserName = () => {
  try {
    const token = getFromLocalStorage('token');
    const decoded = token ? jwt_decode(token) : {};
    return decoded?.FullName || decoded?.Name || '';
  } catch (err) {
    return '';
  }
};

const HeaderUser = () => {
  const [isOpen, setIsOpen] = useState(false);
  const userName = getUserName();

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div className="header-user">
        <button
          type="button"
          className="header-user-trigger"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {userName && <span className="header-user-name">{userName}</span>}
          <span className="header-user-avatar">
            <UserIcon cssClass="header-user-icon" />
          </span>
          <DownArrow customCss={`header-user-caret${isOpen ? ' upside-down' : ''}`} />
        </button>

        {isOpen && (
          <ul className="header-user-menu">
            <li onClick={() => handleLogOut()}>Logout</li>
          </ul>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default HeaderUser;
